export default __webpack_public_path__ + "static/media/Settings.60a03325.svg";